import React, { useState, useEffect, useCallback } from 'react';
import api from '../api';

const InputField = ({ label, ...props }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
      {label}
    </label>
    <input
      {...props}
      className="mt-1 block w-full px-3 py-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
    />
  </div>
);

const NewRmForm = ({ onRmAdded }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone_number: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/rm/rms', formData);
      alert('Relationship Manager created successfully!');
      setFormData({ name: '', email: '', phone_number: '' });
      if (onRmAdded) {
        onRmAdded();
      }
    } catch (error) {
      console.error('Error creating RM:', error.response ? error.response.data : error.message);
      alert(`Error: ${error.response ? error.response.data.message : error.message}`);
    }
  };

  return (
    <div className="p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md mt-8">
      <h2 className="text-3xl font-bold text-gray-800 dark:text-white mb-6">
        Onboard New RM
      </h2>
      <form onSubmit={handleSubmit} className="space-y-6">
        <InputField label="RM Name" name="name" value={formData.name} onChange={handleChange} required />
        <InputField label="RM Email" name="email" type="email" value={formData.email} onChange={handleChange} required />
        <InputField label="RM Phone Number" name="phone_number" value={formData.phone_number} onChange={handleChange} />
        <div className="pt-6">
          <button type="submit" className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            Create RM
          </button>
        </div>
      </form>
    </div>
  );
};

const RmTable = ({ rms }) => (
  <div className="bg-white dark:bg-gray-800 shadow-lg rounded-lg overflow-hidden">
    <table className="min-w-full leading-normal">
      <thead>
        <tr className="bg-gray-50 dark:bg-gray-700">
          <th className="px-6 py-4 border-b-2 border-gray-200 dark:border-gray-600 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">Name</th>
          <th className="px-6 py-4 border-b-2 border-gray-200 dark:border-gray-600 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">Email</th>
          <th className="px-6 py-4 border-b-2 border-gray-200 dark:border-gray-600 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">Phone</th>
        </tr>
      </thead>
      <tbody>
        {rms.map((rm) => (
          <tr key={rm.id} className="hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200">
            <td className="px-6 py-5 border-b border-gray-200 dark:border-gray-600 text-sm"><p className="text-gray-900 dark:text-white whitespace-no-wrap">{rm.name}</p></td>
            <td className="px-6 py-5 border-b border-gray-200 dark:border-gray-600 text-sm"><p className="text-gray-900 dark:text-white whitespace-no-wrap">{rm.email}</p></td>
            <td className="px-6 py-5 border-b border-gray-200 dark:border-gray-600 text-sm"><p className="text-gray-900 dark:text-white whitespace-no-wrap">{rm.phone_number}</p></td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const RmView = () => {
  const [rms, setRms] = useState([]);
  const [isFormVisible, setIsFormVisible] = useState(false);

  const fetchRms = useCallback(async () => {
    try {
      const response = await api.get('/rm/rms');
      setRms(response.data);
    } catch (error) {
      console.error('Error fetching RMs:', error);
    }
  }, []);

  useEffect(() => {
    fetchRms();
  }, [fetchRms]);

  const handleRmAdded = () => {
    fetchRms();
    setIsFormVisible(false);
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-3xl font-bold text-gray-800 dark:text-white">Relationship Managers</h2>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">Manage and onboard new RMs.</p>
        </div>
        <button onClick={() => setIsFormVisible(!isFormVisible)} className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded-lg shadow-md hover:shadow-lg transition-all duration-200">
          {isFormVisible ? 'Cancel' : 'Add New RM'}
        </button>
      </div>
      
      <RmTable rms={rms} />

      {isFormVisible && <NewRmForm onRmAdded={handleRmAdded} />}
    </div>
  );
};

export default RmView;
